import axios, { AxiosPromise } from "axios";
import api from "api/config";
import { stringifyJsonSafely } from "helpers/general";

export const EVENT_NAMES = {
  REG_LEAVING_PAGE_GET_BREEDR: "reg-leaving-page-getBreedr",
  REG_LEAVING_PAGE_GET_BREEDR_DETAILS: "reg-leaving-page-getBreedr-details",
  MSG_SEND_NEW: "msg-send-new",
  IMPORT_BCMS: "import-bcms",
  IMPORT_TRUTEST: "import-trutest",
  IMPORT_FARMPLAN: "import-farmplan",
  IMPORT_APHIS: "import-aphis",
  MED_CAB_BATCH_VIEW: "med-cab-batch-view",
  USER_LOG_IN: "user-log-in",
  REG_LANDING_PAGE_GET_BREEDR: "reg-landing-page-getBreedr",
  REG_LANDING_PAGE_GET_BREEDR_DETAILS: "reg-landing-page-getBreedr-details",
  REG_LANDING_PAGE_GET_BREEDR_SUCCESS: "reg-landing-page-getBreedr-success",
  APP_STARTUP: "app-startup",
  MED_CAB_VIEW: "med-cab-view",
  MED_CAB_VIEW_MED_DETAILS: "med-cab-view-med-details",
  FIELD_CREATE: "field-create",
  FIELD_VIEW: "field-view",
  FIELD_SHOW: "field-show",
  GROUP_CREATE: "group-create",
  GROUP_VIEW: "group-view",
  REPORT_VIEW: "report-view",
  ENTERS_SETTINGS: "enters-settings",
  REG_SAVE_CREDENTIALS: "reg-save-credentials",
  LISTING_CREATE: "listing-create",
  LISTING_UPDATE: "listing-update",
  LISTING_VIEW: "listing-view",
  OFFER_DECISION: "offer-decision",
  LISTING_LIVESTOCK_SHIPPED: "listing-livestock-shipped",
  LISTING_LIVESTOCK_RECEIVED: "listing-livestock-received",
  REGULATORY_REQUEST_DOWNLOAD: "regulatory-request-download",
  REGULATORY_REQUEST_EMAIL: "regulatory-request-email",
  REGULATORY_TRANSACTION_DATE_CHANGED: "regulatory-transaction-date-changed",
  REGULATORY_CONFIRM_MOVE_ONS: "regulatory-confirm-move-ons",
  REGULATORY_CONFIRM_MOVE_OFFS: "regulatory-confirm-move-offs",
  REGULATORY_CONFIRM_BIRTHS: "regulatory-confirm-births",
  REGULATORY_CONFIRM_DEATHS: "regulatory-confirm-deaths",
  REGULATORY_OPENED_DASHBOARD: "regulatory-opened-dashboard",
  REGULATORY_TRANSACTION_ABORTED: "regulatory-transaction-aborted",
  SETTINGS_USERLIST_VIEW: "settings-userlist-view",
  SETTINGS_USER_INVITE: "settings-user-invite",
  SETTINGS_ADDRESS_CREATE: "settings-address-create",
  SAVE_FILTER: "save-filter",
  SIRES_VIEWLIST: "sires-viewlist",
  SIRES_CREATE: "sires-create",
  SETTINGS_VIEW_ADDRESS_BOOK: "settings-view-address-book",
  SETTINGS_CREATE_CONTACT_IN_ADDRESS_BOOOK: "settings-create-contact-in-address-boook",
  SETTINGS_SAVING_BANK_DETAILS: "settings-saving-bank-details",
  SETTINGS_BCMS_PUSH_OPT_IN_OUT: "settings-bcms-push-opt-in-out",
  START_REGULATORY_REQUEST: "start-regulatory-request",
  REGULATORY_REQUEST_STEP_1: "regulatory-request-step1",
  REGULATORY_REQUEST_STEP_2: "regulatory-request-step2",
  ANIMAL_DETETE_ACTIVITY: "animal-delete-activity",
  MSG_SHOW: "msg-show",
  GROUP_SHOW: "group-show",
  ACTIVITY_LOG_ANIMAL: "activity-log-animal",
  ANIMAL_OFFSPRING_VIEW: "animal-offspring-view",
  ANIMAL_HISTORY_VIEW: "animal-history-view",
  ANIMAL_FAMILY_TREE_VIEW: "animal-family-tree-view",
  VIEW_BUYING_LIVEWEIGHT: "view-buying-liveweight",
  LISTING_STARTED_SELLING: "listing-started-selling",
  LISTING_PHOTO_ADDED: "listing-photo-added",
  LISTING_STARTED_BUYING: "listing-started-buying",
  LISTING_STARTED_MY_CATTLE: "listing-started-mycattle",
  LISTING_STARTED_GROUP: "listing-started-groups",
  APP_ACTIVATE: "app-activate",
  SPECIES_SWITCH: "species-switch",
  IMPORT_ADVANCED_ACTIVITIES: "import-advanced-activities",
  IMPORT_ADVANCED_ANIMALS: "import-advanced-animals",
  LISTINGS_FILTER_SMALL_DISTANCE: "listing-filter-small-distance",
  LISTINGS_FILTER_MED_DISTANCE: "listing-filter-med-distance",
  LISTINGS_FILTER_LARGE_DISTANCE: "listing-filter-large-distance",
  LISTINGS_FILTER_ANY_DISTANCE: "listing-filter-any-distance",
  LISTING_FILTER_CATEGORY: "listing-filter-category",
} as const;

export type EventRequestBody = {
  details?: {
    [key: string]: string | number | string[] | number[] | Date | undefined;
  };
  name: ValuesOf<typeof EVENT_NAMES>;
  species?: string;
  username?: string;
};

export const postRequest = (path: string, data: string, host?: string): AxiosPromise =>
  axios.post(`${api.secureProtocol}${host || api.host}${path}`, data, {
    headers: {
      "Content-Type": "application/json",
    },
  });

export const eventsRequest = ({ details, name, species = "", username = "" }: EventRequestBody): AxiosPromise => {
  return postRequest(
    api.endpoints.events,
    stringifyJsonSafely([
      {
        name,
        details: stringifyJsonSafely(details),
        source: "app",
        timestamp: new Date(),
        username,
        platform: "web",
        // eslint-disable-next-line
        app_version: api.version,
        // eslint-disable-next-line
        ip_address: "127.0.0.1",
        species,
      },
    ]),
    api.eventsHost,
  ).catch(() => {
    return {} as unknown as AxiosPromise;
  });
};
